if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        // Cambiado:
        // Vinculamos el handler una sola vez para poder usarlo correctamente
        // dentro del listener de click.
        this.handleLookAddToCart = this.handleLookAddToCart.bind(this);
      }

      connectedCallback() {
        if (super.connectedCallback) {
          super.connectedCallback();
        }

        // Cambiado:
        // Escuchamos clicks dentro del modal de esta look card.
        // Solo actuará si el click viene del botón con data-look-add-to-cart.
        this.addEventListener('click', this.handleLookAddToCart);
      }

      disconnectedCallback() {
        if (super.disconnectedCallback) {
          super.disconnectedCallback();
        }

        // Cambiado:
        // Limpiamos el listener para evitar listeners duplicados.
        this.removeEventListener('click', this.handleLookAddToCart);
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
      }

      async handleLookAddToCart(event) {
        const button = event.target.closest('[data-look-add-to-cart]');

        if (!button) return;

        const variantIds = button.dataset.variantIds
          ? button.dataset.variantIds.split(',').filter(Boolean)
          : [];

        if (!variantIds.length) return;

        const textElement = button.querySelector('[data-look-add-to-cart-text]');
        const originalText = textElement ? textElement.textContent : button.textContent;

        button.disabled = true;
        button.classList.add('btn--loading');
        button.setAttribute('aria-busy', 'true');

        if (textElement) {
          textElement.textContent = 'Añadiendo...';
        } else {
          button.textContent = 'Añadiendo...';
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: variantIds.map((variantId) => ({
                id: Number(variantId),
                quantity: 1,
              })),
            }),
          });

          const responseJson = await response.json();

          if (!response.ok) {
            throw responseJson;
          }

          if (textElement) {
            textElement.textContent = 'Añadido';
          } else {
            button.textContent = 'Añadido';
          }

          // Cambiado:
          // Sleek ya escucha cart:refresh en cart.js.
          // Con open: true, el drawer se refresca y se abre automáticamente.
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: {
                open: true,
              },
            })
          );
        } catch (error) {
          console.error('Error adding look to cart:', error);

          if (textElement) {
            textElement.textContent = 'No se ha podido añadir';
          } else {
            button.textContent = 'No se ha podido añadir';
          }
        } finally {
          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('btn--loading');
            button.removeAttribute('aria-busy');

            if (textElement) {
              textElement.textContent = originalText;
            } else {
              button.textContent = originalText;
            }
          }, 1800);
        }
      }
    }
  );
}